import cx from 'classnames';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { useGlobalContext } from '../../../../context/GlobalContext';
import useSongChangeMetronome from '../plugins/MetronomePlugin/useSongChangeMetronome';
import { getCurrentUser } from '../../../../services/authService';

import { isNewSong } from '../../../../helpers/songDates';
import { isSongAssignedTo } from '../../../../utils/parts';
import { ReactComponent as StarIcon } from '../../../../icons/star-solid.svg';

import './SongCount.scss';

const currentUser = getCurrentUser();

const SongCount = ({ service, songPosition, songs }) => {
  const history = useHistory();
  const { isScrolling } = useGlobalContext();
  const handleMetronomeOnSongChange = useSongChangeMetronome();

  if (!service || !songs || songs.length === 0) return null;

  const handleSongClick = (index) => {
    if (isScrolling) return;

    // Jumping here changes song just like the previous/next buttons do, so the
    // metronome has to follow along instead of keeping the old song's tempo.
    if (index + 1 !== songPosition) {
      handleMetronomeOnSongChange(songs[index]);
    }

    // Navigate to the selected song (index is 0-based, hash is 1-based)
    history.push(`#${index + 1}`);
  };

  const hasUserAssignment = (song) => Boolean(currentUser) && isSongAssignedTo(song, currentUser._id);

  return (
    <div className={cx('SongCount', { disabled: isScrolling })}>
      <div className="bar">
        {songs.map((song, index) => {
          const userHasAssignment = hasUserAssignment(song);
          const isNew = isNewSong(song.createdAt, song.isNewSong);
          const segmentClasses = cx('segment', {
            active: index + 1 === songPosition,
            'category-worship': !isNew && song.category?.name?.toLowerCase() === 'worship',
            'category-praise': !isNew && song.category?.name?.toLowerCase() !== 'worship',
            'is-new': isNew,
            'has-assignment': userHasAssignment,
          });

          return (
            <div
              key={song._id || index}
              className={segmentClasses}
              onClick={!isScrolling ? () => handleSongClick(index) : undefined}
              title={song.title}
            >
              <span className="number">{index + 1}</span>
              {userHasAssignment && <StarIcon className="assignment-star" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

SongCount.propTypes = {
  service: PropTypes.object.isRequired,
  songPosition: PropTypes.number.isRequired,
  songs: PropTypes.array.isRequired,
};

export default SongCount;
